<div class="modal-body">
  <div
    *ngIf="listOwnersEditorState.savingError ? true : false"
    class="alert alert-danger qa-saving-error"
    role="alert"
  >
    <strong i18n="@@listOwnersEditor-status-errorSaving">Error!</strong>
    <ng-container i18n="@@listOwnersEditor-status-errorSavingPleaseRetry"
      >There was an error saving list owners for your list. Please try
      again.</ng-container
    >
  </div>

  <div
    *ngIf="submitted && listOwnersForm.invalid"
    class="alert alert-danger qa-error-summary"
    role="group"
  >
    <h2 class="h5" i18n>There's a problem</h2>
    <ul class="m-0">
      <li
        *ngIf="listOwnersFormArray.errors?.tooManyOwners"
        i18n="@@listOwnersEditor-errorSummary-tooManyOwners"
      >
        A maximum of {{ MAX_OWNERS_COUNT }} owners can be configured
      </li>
    </ul>
  </div>

  <div class="c-list-owners-editor__form">
    <rl-user-search-field
      [currentUser]="currentUser"
      [disabled]="listOwnersEditorState.isSaving"
      (userSelected)="addListOwner($event)"
      class="c-list-owners-editor__form__search"
    >
    </rl-user-search-field>

    <div
      *ngIf="listOwnersFormArrayEmpty"
      class="alert alert-info qa-no-list-owners"
      role="status"
      i18n="@@listOwnersEditor-status-noListOwners"
    >
      No list owner is currently selected. Use the search box above to search
      list owner by name or email.
    </div>

    <form [formGroup]="listOwnersForm">
      <table class="table c-list-owners-editor__form__table">
        <tbody>
          <tr
            formArrayName="owners"
            *ngFor="let owner of listOwnersFormArray.value; index as index"
            class="qa-list-owners"
          >
            <td class="c-list-owners-editor__form__table__owner-name">
              <rl-avatar [user]="owner.id" [size]="40"></rl-avatar>
              <span>{{ owner.full_name }}</span>
            </td>
            <td class="c-list-owners-editor__form__table__owner-role">
              <span
                class="c-list-owners-editor__form__table__owner-role"
                i18n="@@listOwnersEditor-label-ownerJobRole"
                >{owner.job_role_description, select, academic {an academic}
                teacher {a teacher} lecturer {a lecturer} educational_support
                {educational support} undergraduate {an undergraduate}
                postgraduate {a postgraduate} researcher {a researcher}
                librarian {a librarian} learning_technologist {a learning
                technologist} non_teaching_faculty {non-teaching faculty}}</span
              >
            </td>
            <td class="c-list-owners-editor__form__table__remove-button">
              <button
                [disabled]="listOwnersEditorState.isSaving"
                (click)="removeListOwner(index)"
                class="btn btn-link btn-danger qa-remove-button"
                type="button"
                aria-label="Remove list owner"
                i18n-aria-label="@@listOwnersEditor-button-removeListOwner"
              >
                <i class="fas fa-minus-circle" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-default qa-cancel"
    i18n="@@listOwnersEditor-btn-cancel"
    (click)="onCancel()"
  >
    Cancel
  </button>

  <button
    *ngIf="hasInviteListPublishersPermission"
    [disabled]="listOwnersEditorState.isSaving || listOwnersFormArrayEmpty"
    (click)="onSubmit(true)"
    type="button"
    class="btn btn-primary qa-saveWithPublisherRole"
  >
    <ng-container
      *ngIf="listOwnersEditorState.isSaving && saveWithPublisherRoleClicked"
    >
      <span
        class="text-center qa-saveWithPublisherRole-saving-spinner"
        role="status"
      >
        <i class="fas fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
        <span
          class="sr-only"
          i18n="@@listOwnersEditor-saveWithPublisherRole-spinner"
          >Saving...</span
        >
      </span>
    </ng-container>

    <ng-container i18n="@@listOwnersEditor-btn-saveWithPublisherRole"
      >Save with list publisher role</ng-container
    >
  </button>
  <button
    [disabled]="listOwnersEditorState.isSaving"
    (click)="onSubmit(false)"
    type="button"
    class="btn btn-primary qa-save"
  >
    <ng-container
      *ngIf="listOwnersEditorState.isSaving && !saveWithPublisherRoleClicked"
    >
      <span class="text-center qa-save-saving-spinner" role="status">
        <i class="fas fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
        <span class="sr-only" i18n="@@listOwnersEditor-save-spinner"
          >Saving...</span
        >
      </span>
    </ng-container>

    <ng-container i18n="@@listOwnersEditor-btn-save">Save</ng-container>
  </button>
</div>
